import { IsInt } from 'class-validator';

export class ProfileCategoryDeleteRequest {
    @IsInt()
    public id: number;

    constructor(data?: Partial<ProfileCategoryDeleteRequest>) {
        this.id = data && data.id;
    }
}
